import {Component, OnDestroy, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-tabs',
    templateUrl: './block-tabs.component.html',
})

export class BlockTabsComponent extends BlockAbstractComponent implements OnInit, OnDestroy {
    activeTabIndex: number = 0;

    prevSelectedTabs: boolean[] = [];

    prevSelectedTabsKey: string = 'OE:prevSelectedTabs';

    isStyle1?: boolean;
    isStyle2?: boolean;

    override ngOnInit() {
        super.ngOnInit();
        this.isStyle1 = this.block.data.style === 'style1';
        this.isStyle2 = this.block.data.style === 'style2';

        if (this.isStyle2) {
            const getPrevSelectedTabs = localStorage.getItem(this.prevSelectedTabsKey);

            if (getPrevSelectedTabs) {
                this.prevSelectedTabs = JSON.parse(getPrevSelectedTabs);
            } else {
                this.block.content.forEach(() => {
                    this.prevSelectedTabs.push(false);
                });
            }

            this.setPeviouslySelectedTabs();
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        if (this.isStyle2) {
            this.setPeviouslySelectedTabs();
        }
    }

    tabChange($event: { index: number; }) {
        if (!this.prevSelectedTabs[this.activeTabIndex] && this.isStyle2) {
            this.prevSelectedTabs[this.activeTabIndex] = true;

            this.setPeviouslySelectedTabs();
        }

        this.activeTabIndex = $event.index;
    }

    setPeviouslySelectedTabs() {
        localStorage.setItem(this.prevSelectedTabsKey, JSON.stringify(this.prevSelectedTabs));
    }

}
